import { SxProps } from '@mui/material'

export const baseTemplateStyles: SxProps = {
  backgroundColor: 'background.default',
}
